export function isFoldable(element: HTMLElement) {
    return element.scrollHeight > element.clientHeight;
}
